import { Inject, Injectable } from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { lastValueFrom, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { AppMsalConfig } from "src/app-msal-config";
import { GroupsService } from "src/app/groups/groups.service";
import { ExdrLanguageService } from 'src/app/languages/services/exdr-language.service';
import { environment } from "src/environments/environment";
import { SharedService } from '../shared.service';
import { AuthService } from './auth.service';

@Injectable()
export class CustomDomainService {

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private groupsService: GroupsService,
    private sharedService: SharedService,
    private langService: ExdrLanguageService,
    private authService: AuthService,
    private router: Router
  ) {
  }

  Init() {
    this.sharedService.setDefaultTitleAndFavicon('Loading...');
    const url = new URL(this.document.location.href);
    const groupId = url.searchParams.get('gid');
    this.configureSingleGroupApp(groupId);
    // window['GROUP_IDENEDI'] = "GUX1999032800";
    let request$ = window['GROUP_IDENEDI'] ? of(window['GROUP_IDENEDI']) : this.groupsService.getGroupIdByDomain(this.document.location.host)
    if (environment.enableGroupsSelection) {
      return lastValueFrom(request$
        .pipe(
          concatMap(groupId => {
            if (groupId && this.isJsonString(groupId)) {
              if (this.isParentSublink()) {
                this.redirectToFirstDomain(groupId);
                return of(groupId);
              } else {
                this.router.navigateByUrl('/auth/multi-group-domains');
                return of(groupId);
              }
            } else if (this.isUrl(groupId)) {
              this.document.location.href = groupId;
              return of(groupId);
            } else if (!groupId && environment.customDomainFallbackUrl && environment.customDomainFallbackUrl != this.document.location.host) {
              this.document.location.href = environment.customDomainFallbackUrl;
              return of(groupId);
            } else {
              this.configureSingleGroupApp(groupId)
              this.sharedService.setDefaultTitleAndFavicon();
              return this.initializeLanguage(groupId);
            }
          }),
          catchError(error => {
            console.error('CustomDomainService Init failed:', error);
            // If logged in with expired token, clear auth state
            if (this.authService.isLoggedIn() && this.authService.isIdenediTokenExpired()) {
              this.authService.logout(false);
            }
            this.sharedService.setDefaultTitleAndFavicon();
            return of(null);
          })
        ));
    }
    else {
      this.sharedService.setDefaultTitleAndFavicon();
      return lastValueFrom(this.initializeLanguage().pipe(
        catchError(error => {
          console.error('CustomDomainService initializeLanguage failed:', error);
          // If logged in with expired token, clear auth state
          if (this.authService.isLoggedIn() && this.authService.isIdenediTokenExpired()) {
            this.authService.logout(false);
          }
          return of(null);
        })
      ));
    }

  }
  private isUrl(groupId: string): boolean {
    groupId = (groupId ?? '').trim().toLowerCase();
    return groupId.startsWith('http://') || groupId.startsWith('https://');
  }

  configureSingleGroupApp(groupId: string) {
    if (groupId && groupId !== "*") {
      groupId = groupId.split('_')[0]
      environment.enableGroupsSelection = false;
      environment.singleGroupApp = true;
      environment.idenediGroupId = groupId;

      AppMsalConfig.groupId = groupId;
      AppMsalConfig.accessToken = localStorage.getItem(
        AppMsalConfig.groupId + "_msalToken"
      );
    }
  }

  private initializeLanguage(groupId?) {
    if (groupId && groupId !== "*") {
      return this.authService.getAddonsAuth(groupId);
    } else {
      this.langService.initializeLanguage();
      return of(groupId);
    }
  }

  private isJsonString(str) {
    if (!str) {
      return false;
    }
    try {
      JSON.parse(str);
      if (typeof JSON.parse(str) == "number") {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  }

  private isParentSublink() {
    const currentUrl = new URL(this.document.location.href);
    if (currentUrl.pathname == '/' || currentUrl.pathname == '/auth/multi-group-domains') {
      return false;
    } else {
      return true;
    }
  }

  private redirectToFirstDomain(groupId: string) {
    let subDomains = JSON.parse(groupId);
    let urls = subDomains.map(sd => sd.RedirectUri).filter((url: string) => url.startsWith('http'));
    const firstDomain = urls[0];
    let currentUrl = new URL(this.document.location.href);
    this.document.location.href = `${firstDomain}${currentUrl.pathname.substring(1)}${currentUrl.search}${currentUrl.hash}`;
  }


}
